import React from 'react';
import './aboutUS.css';

const AboutUS = () => {
    return(
        <div className="container">
            <div className="aboutUS"></div>
        </div>
    )
}
export default AboutUS;